// React
import React from 'react';
// External
import { Form, Col, Image, Row } from 'react-bootstrap';

import '@splidejs/react-splide/dist/css/splide.min.css';

import COLLECTION_ADDRESS_OPTIONS from 'constants/collectionAddressOptions';

// Styles
import './styles.scss';
// Models
import CollectionDetailsModel from 'models/CollectionDetails';

import CustomSelect from 'components/shared/atoms/CustomSelect/CustomSelect';

import GooglePlacesAutocomplete, { geocodeByPlaceId } from 'react-google-places-autocomplete';
import Address from 'models/Address';
import config from 'config/config';
import getFormFieldVal from 'utils/getFormFieldVal';
import isEmpty from 'lodash/isEmpty';
import HomeCollectionProduct from '../HomeCollectionProduct/HomeCollectionProduct';
import { BookingContext } from 'context/BookingContext';

/**
 * @param {string} props.data - The text to be display in the previous button
 * @param {string} props.className - The className to be added to the form
 */
class CollectionDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: CollectionDetailsModel(this.props.formData),
            errors: [],
            isLoading: false,
            hideCollectionAddressField: true,
            addressMenuIsOpen: false,
            input: this.props.formData.collectionAddress ? this.props.formData.collectionAddress.getSingleLineAddress() : '',
            collectionAddressOptions: [],
            bookingForm: {},
            filteredOptions: [], // Add this to store filteredOptions
            hasErrorOtherAddress: false,
            hasErrorCollectionAddress: false,
        };

        this.dropdownRefs = {
            collectionAddressOption: React.createRef(),
        };
        this.bOpenOptions = false;
        this.bEnterPressed = false;    
    }

    handleFilteredOptionsChange = (filteredOptions) => {
        const isCustomerAddress = this.state.formData.collectionAddressOption === 'customer_address';
    
        if (filteredOptions.length === 0) {
            this.setState({
                hasErrorOtherAddress: true,
                hasErrorCollectionAddress: isCustomerAddress, // only true if it's 'customer_address'
            });
        } else {
            this.setState({
                hasErrorOtherAddress: false,
                hasErrorCollectionAddress: isCustomerAddress ? false : this.state.hasErrorCollectionAddress,
            });
        }
    };

    componentDidMount() {
        localStorage.setItem('collectionAddressLat', this.state.formData.collectionAddress.lat);
        localStorage.setItem('collectionAddressLng', this.state.formData.collectionAddress.lng);
            this.setState(prev => {
                const prevState = prev

                if (isEmpty(this.state.formData.collectionAddressOption)) {
                    prevState.formData.collectionAddressOption = this.props.defaultCollectionOption
                }

                if (this.state.formData.collectionAddressOption === 'postal_address') {
                    prevState.hideCollectionAddressField = false
                    prevState.input = this.state.formData.collectionAddress?.getSingleLineAddress()
                }
                
                return prevState
            })
        // If there is a previous form data and breed data, get the corresponding breed options for it
        // if (this.props.formData && this.props.formData.breed) {
        //     this.getPetBreedOptions(this.props.formData.breed, [], { page: 1 });
        //     this.setState({ autoloadBreedDropdown: true });
        // }
    }

    componentDidUpdate(prevProps) {
        
        this.checkBookingForm(prevProps).updateCollectionAddressOption(prevProps)
    }

    checkBookingForm(prevProps) {
        if(!prevProps?.bookingForm && !this.props.bookingForm) {
            throw new Error('Booking Form not found try adding as a props')
        }

        return this
    }

    // added so that when skip is true then the owners home address will remove in the selection and empty the selection
    updateCollectionAddressOption(prevProps) {
        let _collectionAddressOptions = [
            { name: "Owner's Home Address", value: 'customer_address' },
            { name: 'Vet Address', value: 'vet_address' },
            { name: 'Other Home Address', value: 'postal_address' },
        ]
        const skipUpdated = (prevProps?.bookingForm.skip !== undefined && this.props?.bookingForm.skip !== undefined) && 
        prevProps?.bookingForm.skip !== this.props.bookingForm.skip

        if (!this.state.collectionAddressOptions.length || (skipUpdated)) {
            if (this.props.bookingForm.skip) {
                _collectionAddressOptions.shift()
                this.state.formData.collectionAddressOption === 'customer_address' && this.setState(prev => {
                    let prevState = {
                        ...prev,
                        formData: {
                            ...prev.formData,
                            collectionAddressOption: ''
                        }
                    }

                    return prevState
                })
            }


            this.setState({
                collectionAddressOption: this.state.formData.collectionAddressOption,
                collectionAddressOptions: _collectionAddressOptions
            })
        } 
    }
    /**
     * Function call from the parent component
     */
    async handleSubmit(BookingContext) {
        if (this.state.formData.collectionAddressOption == 'postal_address') {
            this.onAddressSelect(this.state.formData.collectionAddressOption);
        }
      
        let errors = [];

        try {
            await this.setState((prevState) => {
                errors = prevState.formData.validateRequiredData();
                // Check if there is no selected breed
                const hasNotSelectedCollectionAddress = this.getError('collectionAddressOption') === 'Error in selecting collection address option';
                const collectionProducts = BookingContext.collectionDetails.collectionProducts

                if(['postal_address', 'customer_address'].includes(BookingContext?.collectionDetails?.collectionAddressOption) && !collectionProducts.length) {
                    this.addError(errors, 'collectionProducts', 'Collection Product is Required')
                }

                if(!BookingContext?.collectionDetails?.collectionAddressOption) {
                    this.addError(errors, 'collectionAddressOption', 'Collection Address Option is required')
                }

                if(['postal_address'].includes(BookingContext?.collectionDetails?.collectionAddressOption) && !BookingContext?.collectionDetails?.collectionAddress?.lat) {
                    this.addError(errors, 'collectionAddress', 'Collection Address is required')
                }

                if (hasNotSelectedCollectionAddress) {
                    this.addError(errors, 'collectionAddressOption', 'Error in selecting collection address option');
                }

                return { errors };
            });
        } catch (error) {
            console.error(error);
        }

        // Returns the data if the form has no errors
        return errors.length > 0 ? null : BookingContext.collectionDetails;
    }

    removeError = (errorList, errorName) => {
        const errIndex = errorList.findIndex(error => error.field === errorName);
        if (errIndex >= 0) {
            const errors = errorList;
            errors.splice(errIndex, 1);
            return errors;
        }
        return errorList;
    }

    hasError(fieldError) {
        return this.state.errors.some(error => error.field === fieldError);
    }

    /**
     * Get the provided field's error message
     *
     * @param {string} fieldError
     * @returns {string}
     */
     getError(fieldError) {
        const error = this.state.errors.filter(error => error.field === fieldError);
        if (error.length !== 0) {
            return error[0].message;
        }
    }

    /**
     * Adds an error to the error array
     *
     * @param {array} errors
     * @param {string} field
     * @param {string} message
     * @returns {void}
     */
    addError(errors, field, message) {
        const errIndex = errors.findIndex(error => error.field === field);

        if (errIndex < 0) {
            errors.push({
                field: field,
                message: message
            });
        } else {
            errors[errIndex].message = message;
        }
    }



    /**
     * Event handler for when the user selects an option in the dropdown using the *Tab* key
     *
     * @param {Event} objEvent Event object
     * @param {Function} fnHandler Function for the change handler of the field
     * @param {String} strErrorMessage Error message when selecting an option
     * @param {Object} objRef Object reference for the input field dropdown
     *
     * @returns {void}
     */
    onOptionsKeyDown(objEvent, fnHandler, strErrorMessage, objRef) {
        if (objEvent.key === 'Tab') {
            try {
                setTimeout(() => fnHandler(), 50)
            } catch(objError) {
                console.log(strErrorMessage, objError);
            }
        }
    }

    /**
     * Event handler for when the pet sex changes
     *
     * @param {String} strPetType Selected pet sex option value from the dropdown
     *
     * @returns {void}
     */
    onCollectionAddressOptionChange(addressOption, _BookingContext) {
        this.setState((prevState) => {

            // if (address == 'postal_address') {
            //     this.state.hideCollectionAddressField = false;
            // } else {
            //     this.state.hideCollectionAddressField = true;
            // }

            this.state.hideCollectionAddressField = addressOption !== 'postal_address';
            const formData = { ...prevState.formData, ...{ collectionAddressOption: addressOption } };
            const errors = this.removeError(prevState.errors, 'collectionAddressOption');
            const input = '';
            _BookingContext.setState(prev => {
                return {
                    ...prev,
                    collectionDetails: {
                        ...prev.collectionDetails,
                        collectionProducts: []
                    },
                    isDefaultLocation: false
                }
            })

            return { formData, errors, input };
        });

        // If collection address option changes customer_address = collectionDetails.collectionAddress will back to empty
        // if postal_address = owner.address will back to empty
        _BookingContext && _BookingContext.setState(prev => {
            return {
                ...prev,
                collectionDetails: {
                    ...prev.collectionDetails,
                    collectionAddressOption: addressOption,
                    collectionAddress: ['customer_address', 'vet_address'].includes(addressOption) ? Address('') : prev.collectionDetails.collectionAddress
                }
            };
        });
    }

    onAddressSelect(addressObj, _BookingContext) {
        const updateErrors = (field, message = null) => {
            this.setState((prevState) => {
                const { errors } = prevState;
                const errIndex = errors.findIndex(error => error.field === field);
                if (message) {
                    if (errIndex === -1) errors.push({ field, message });
                } else {
                    if (errIndex >= 0) errors.splice(errIndex, 1);
                }
                return { errors };
            });
        };
    
        const setAddress = (address) => {
            this.setState((prevState) => {
                const formData = { ...prevState.formData, collectionAddress: address };
                updateErrors('collectionAddress');
                return { formData };
            });
        };

        if (addressObj === 'postal_address') {
            // Try facility location fields first (ol_address_* from operational location join)
            const facilityDetails = this.props.formData.facilityLocationDetails || this.props.formData.officeLocationDetails;
            const officeDetails = this.props.formData.officeLocationDetails;
            let address;
            
            // If facility details have ol_address_* fields, use those
            if (facilityDetails && (facilityDetails.ol_address_street_c || facilityDetails.ol_address_street)) {
                address = {
                    street: facilityDetails.ol_address_street_c || facilityDetails.ol_address_street || '',
                    lat: facilityDetails.ol_address_latitude_c || facilityDetails.ol_address_latitude || null,
                    lng: facilityDetails.ol_address_longitude_c || facilityDetails.ol_address_longitude || null,
                    city: facilityDetails.ol_address_city_c || facilityDetails.ol_address_city || '',
                    state: facilityDetails.ol_address_state_c || facilityDetails.ol_address_state || '',
                    postalcode: facilityDetails.ol_address_postalcode_c || facilityDetails.ol_address_postalcode || '',
                };
            } else {
                // Fall back to office address fields for backward compatibility
                address = {
                    street: officeDetails?.office_address_street,
                    lat: officeDetails?.office_address_latitude,
                    lng: officeDetails?.office_address_longitude,
                    city: officeDetails?.office_address_city,
                    state: officeDetails?.office_address_state,
                    postalcode: officeDetails?.office_address_postalcode,
                };
            }
    
            updateErrors('address_city', address.city ? null : 'City not found');
            updateErrors('address_postalcode', address.postalcode ? null : 'Postal code not found');
            setAddress(Address(address));
        } else if (!addressObj) {
            setAddress(null);
        } else {
            const placeId = addressObj.value.place_id;
    
            geocodeByPlaceId(placeId)
                .then((result) => {
                    if (!result.length) {
                        updateErrors('address', 'Error in selecting address');
                        return;
                    }
    
                    const address = {
                        street: addressObj.value.structured_formatting.main_text,
                        lat: result[0].geometry.location.lat(),
                        lng: result[0].geometry.location.lng(),
                    };
    
                    result[0].address_components.forEach((element) => {
                        const { types, short_name, long_name } = element;
                        if (types.includes('subpremise') && !address.street.includes(short_name)) {
                            address.street = `${short_name}/${address.street}`;
                        }
                        if (types.includes('locality')) address.city = long_name;
                        if (types.includes('administrative_area_level_1')) address.state = short_name;
                        if (types.includes('country')) address.country = long_name;
                        if (types.includes('postal_code')) address.postalcode = long_name;
                    });
    
                    updateErrors('address_city', address.city ? null : 'City not found');
                    updateErrors('address_postalcode', address.postalcode ? null : 'Postal code not found');
                    setAddress(Address(address));
                
                _BookingContext && _BookingContext.setState(prev => {
                    return {
                        ...prev,
                        collectionDetails: {
                            ...prev.collectionDetails,
                            collectionAddress: address,
                            collectionProducts: prev.collectionDetails.collectionAddressOption === 'postal_address' ? [] : prev.collectionDetails.collectionProducts
                        },
                        errors: {
                            ...prev.errors,
                            collectionDetails: {
                                ...prev.errors.collectionDetails,
                                collectionProducts: null
                            }
                        },
                        isDefaultLocation: false
                    };
                });
                })
                .catch((error) => console.error(error));
        }
    }

    handleInputChange(event) {
        const fieldObj = getFormFieldVal(event);
        // Updates the state
        this.setState((prevState) => {
            const formData = CollectionDetailsModel({ ...prevState.formData, ...{collectionAddress: {...prevState.formData.collectionAddress, ...fieldObj}} });
            const errors = this.removeError(prevState.errors, event.target.name);
            return { formData, errors };
        });
    }

    render() {
        return (
            <BookingContext.Consumer>
                {_BookingContext => 
                     <Form className={`pet-custom-inline-form ${this.props.className ? this.props.className : ''}`}>
                        <div className="form-header">Collection Details</div>
                        <Row className="mx-0">
                            <Col className="pl-0" lg={6}>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="collectionAddressOption" className="control-group">
                                        <Form.Label className={this.hasError('collectionAddressOption') || this.state.hasErrorCollectionAddress ? 'is-invalid custom-error-select'  : ''}>COLLECTION ADDRESS *</Form.Label>
                                        <CustomSelect
                                            ref={this.dropdownRefs.collectionAddressOption}
                                            search={true}
                                            options={this.state.collectionAddressOptions}
                                            name="collectionAddressOption"
                                            controlClassName={this.hasError('collectionAddressOption') || this.state.hasErrorCollectionAddress  ? 'is-invalid custom-error-select' : ''}
                                            hasError={this.hasError('collectionAddressOption') || this.state.hasErrorCollectionAddress }
                                            value={this.state.formData.collectionAddressOption}
                                            onChange={(value) => {
                                                this.onCollectionAddressOptionChange(value, _BookingContext);
                                            }}
                                            onKeyDown={(e) =>
                                                this.onOptionsKeyDown(
                                                    e,
                                                    () => e.target.closest('.form-row').nextElementSibling.querySelector('input.form-control').focus(),
                                                    'Error in selecting collection address option',
                                                    this.dropdownRefs.collectionAddressOption
                                                )
                                            }
                                        />
                                    </Form.Group>
                                    {this.state.hasErrorCollectionAddress && (
                                        <div className="invalid-feedback d-block">
                                            {this.state.filteredOptions?.length === 0
                                                ? 'ADDRESS IS OUTSIDE AVAILABLE COLLECTION ZONES'
                                                : this.getError('collectionAddress')}
                                        </div>
                                    )}
                                </Form.Row>
                            </Col>
                            { !this.state.hideCollectionAddressField ?
                            <Col className="pl-0" lg={6}>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="collectionAddress" className="control-group pl-0 mb-2">
                                        <Form.Label className={this.hasError('collectionAddress') || this.state.hasErrorOtherAddress == true ? 'is-invalid custom-error-select' : ''}>OTHER HOME ADDRESS *</Form.Label>
                                        {
                                            <GooglePlacesAutocomplete
                                                apiKey={config.GOOGLE_MAPS_KEY}
                                                apiOptions={{ language: 'en', region: 'au' }}
                                                minLengthAutocomplete="3"
                                                selectProps={{
                                                    onChange: (value) => { this.onAddressSelect(value, _BookingContext); },
                                                    onInputChange: (value, action) => {
                                                        if (action?.action !== 'input-blur' && action?.action !== 'menu-close') {
                                                        this.setState({ input: value });
                                                        }
                                                        if (value) {
                                                            this.onAddressSelect('');
                                                        }
                                                        this.setState((prevState) => {
                                                            const errIndex = prevState.errors.findIndex(
                                                                (error) => error.field === 'collectionAddress'
                                                            );
                                                            if (errIndex >= 0) {
                                                                const { errors } = prevState;
                                                                errors.splice(errIndex, 1);
                                                                return { addressMenuIsOpen: value.length >= 3, errors };
                                                            }
                                                            return { addressMenuIsOpen: value.length >= 3 };
                                                        });
                                                    },
                                                    className: 'address-select-container ',
                                                    classNamePrefix: 'address-select',
                                                    menuIsOpen: this.state.addressMenuIsOpen,
                                                    inputValue: this.state.input,
                                                    styles: {
                                                        control: (provided, { isFocused }) => ({
                                                            ...provided,
                                                            fontWeight: '300',
                                                            fontSize: '18px',
                                                            lineHeight: '22px',
                                                            minWidth: '380px',
                                                            minHeight: '60px',
                                                            maxHeight: '60px',
                                                            height: '60px',
                                                            borderRadius: '4px',
                                                            backgroundColor: '#fff',
                                                            border: `solid ${this.hasError('collectionAddress') || this.state.hasErrorOtherAddress == true  ? '2px #dc3545' : '1px #77878A'} !important`,
                                                            // is Focus
                                                            borderColor: this.hasError('collectionAddress') || this.state.hasErrorOtherAddress == true  ? '#dc3545' : (isFocused ? '#77878A' : 'null'),
                                                            outline: 0,
                                                            // eslint-disable-next-line no-nested-ternary
                                                            boxShadow: isFocused
                                                                ? this.hasError('collectionAddress') || this.state.hasErrorOtherAddress == true
                                                                    ? '0 0 0 0.2rem rgb(220 53 69 / 25%)'
                                                                    : '0 0 0 0.1rem #5eb5c1'
                                                                : null,
                                                        }),
                                                    },
                                                    placeholder: '',
                                                }}
                                            />
                                        }
                                    </Form.Group>
                                    {this.state.hasErrorOtherAddress && (
                                        <div className="invalid-feedback d-block">
                                            {this.state.filteredOptions?.length === 0
                                                ? 'ADDRESS IS OUTSIDE AVAILABLE COLLECTION ZONES'
                                                : this.getError('collectionAddress')}
                                        </div>
                                    )}

                                </Form.Row>
                            </Col>
                            : null
                        }
                        </Row>
                        
                        <HomeCollectionProduct
                            error={this.hasError('collectionProducts')}
                            onFilteredOptionsChange={this.handleFilteredOptionsChange} // Pass the callback
                        />
                    </Form>
                }
            </BookingContext.Consumer>
           
        );
    }
}

export default CollectionDetails;